import { useSyncExternalStore } from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';

import { preference, subscribe, setTheme, type ThemePreference } from './theme';

export function ThemeToggle() {
  const value = useSyncExternalStore(subscribe, preference, () => 'system' as const);
  const Icon = value === 'dark' ? Moon : value === 'light' ? Sun : Monitor;
  return <label className="theme-toggle"><Icon size={16} aria-hidden="true" /><span className="sr-only">Color theme</span><select aria-label="Color theme" value={value} onChange={event => {
    setTheme(event.target.value as ThemePreference);
  }}><option value="light">Light</option><option value="dark">Dark</option><option value="system">System</option></select></label>;
}
